import TextField, { TextFieldProps } from '@mui/material/TextField';
import { useField } from 'formik';
import FieldMessage from './FieldMessage';

interface Props extends TextFieldProps<'outlined'> {
  name: string;
  maxCharacterCount?: number;
}

export const AppTextField = ({
  name,
  maxCharacterCount,
  ...restProps
}: Props) => {
  const [field, { error, touched }] = useField(name);

  const valueLength = typeof field.value === 'string' ? field.value.length : 0;

  return (
    <TextField
      {...field}
      {...restProps}
      error={!!error && touched}
      inputProps={
        maxCharacterCount ? { maxLength: maxCharacterCount } : undefined
      }
      FormHelperTextProps={{ component: 'div' }}
      helperText={
        <FieldMessage
          error={Boolean(error)}
          touched={touched}
          name={name}
          valueLength={valueLength}
          maxCharacterCount={maxCharacterCount}
        />
      }
    />
  );
};
